import {
    BookOpen,
    Video,
    Code2,
    Award,
    User,
    FileText,
    Calendar,
    Compass,
    Sparkles,
    CheckSquare,
    Settings,
    Bell,
    HelpCircle,
    GraduationCap,
    FolderGit2,
    MessageSquare,
    Terminal,
    LayoutDashboard,
    Database,
    Star,
    type LucideIcon,
} from 'lucide-react';

export const MODULE_ICON_MAP: Record<string, LucideIcon> = {
    BookOpen,
    Video,
    Code2,
    Award,
    User,
    FileText,
    Calendar,
    Compass,
    Sparkles,
    CheckSquare,
    Settings,
    Bell,
    HelpCircle,
    GraduationCap,
    FolderGit2,
    MessageSquare,
    Terminal,
    LayoutDashboard,
    Database,
    Star,
};

export const ICON_OPTIONS = Object.keys(MODULE_ICON_MAP).map(key => ({
    value: key,
    label: key,
}));

export const getModuleIcon = (iconName?: string): LucideIcon => {
    if (!iconName) return BookOpen;
    return MODULE_ICON_MAP[iconName] || BookOpen;
};
